import { render } from "./Cookie.vue?vue&type=template&id=0baee1a4&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=0baee1a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0baee1a4"

export default script